import api from '@http/api';
import { IPerfil } from '@interfaces/UserComplete';

interface IInserirDoacao {
  doacaoId: number;
  perfilId: string;
  estrategiaId: string;
  origemDoacaoId: string;
  valorDoacao: number;
  dataDoacao: string;
  observacao: string;
}

export interface IFormaContribuicao {
  id: string;
  descricao: string;
  data_cadastro: string;
  status_ativo: boolean;
}

export interface IEstrategias {
  id: string;
  nome: string;
  campanha_id: string;
  descricao: string;
}

export interface IResponseRequestPessoaByCPF {
  pessoa: {
    id: string;
    documento: string;
    nome: string;
    perfis: IPerfil[];
    tipos_perfis: string[];
  };
}

export interface IResponsePessoaByCPF {
  response?: {
    pessoa: {
      id: string;
      nome: string;
      documento: string;
      perfis: IPerfil[];
      tipos_perfis: string[];
    };
  };
  error: boolean;
}

export interface IResponse {
  response?: IPerfil[];
  error: boolean;
}

interface IResponseDoacao {
  error: boolean;
  response?: IDoacao;
}

export interface IDoacao {
  id: number;
  perfil_id: string;
  perfil_tipo: string;
  data_doacao: any;
  data_cadastro: any;
  observacao: string;
  valor_doacao: number;
  estrategia_id: string;
  estrategia_descricao: string;
  origem_doacao_id: string;
  origem_doacao_descricao: string;
  doador_id: string;
  doador_nome: string;
}

class Services {
  public async loadFormaContribuicao() {
    return await api
      .get<IFormaContribuicao[]>('/api/Doacao/GetOrigensDoacao')
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async loadEstrategias() {
    return await api
      .get<IEstrategias[]>('/api/Estrategia/GetEstrategiasFiltradas')
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async getPessoaByID(id: number): Promise<IResponsePessoaByCPF> {
    return await api
      .get(`api/Pessoa/GetPessoaById/${id}`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
        };
      });
  }

  public async getPessoaByDocumento(
    documento: string,
  ): Promise<IResponsePessoaByCPF> {
    return await api
      .post<IResponseRequestPessoaByCPF>(`api/Pessoa/FindPessoaByCpf`, {
        documento,
      })
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
        };
      });
  }

  public async inserirDoacao({
    doacaoId,
    estrategiaId,
    origemDoacaoId,
    perfilId,
    valorDoacao,
    dataDoacao,
    observacao,
  }: IInserirDoacao): Promise<{ error: boolean; doacaoId?: number }> {
    return await api
      .put(`api/Doacao/UpdateDoacao`, {
        doacaoId,
        estrategiaId,
        origemDoacaoId,
        perfilId,
        valorDoacao,
        dataDoacao,
        observacao,
      })
      .then(response => {
        const doacaoId = response.data?.id;
        console.log('ID da doação retornado pela API:', doacaoId);
        return {
          error: false,
          doacaoId,
        };
      })
      .catch(() => {
        return { error: true };
      });
  }

  public async gerarRecibo(doacaoId: number): Promise<{ error: boolean; response?: Blob }> {
    return await api
      .get(`/api/Doacao/GetReciboDoacao`, {
        params: { doacaoId },
        responseType: 'blob',
      })
      .then(response => ({
        error: false,
        response: response.data,
      }))
      .catch(() => ({ error: true }));
  }

  public async GetPegaInfosDoacao(id_perfil: any): Promise<IResponseDoacao> {
    return await api
    .get<IDoacao>(`api/Doacao/GetDoacaoById/${id_perfil}`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };

      })
      .catch(error => {
        return {
          error: true,
        };
      });

  }

  public async loadPessoas({ data }: IRequestData): Promise<IResponsePessoa> {
    return await api
      .post('api/Pessoa//api/Pessoa/FindSinglePessoa', data)
      .then(response => {
        const pessoas = response.data.modelo;
        const total_itens = response.data.total_itens;
        const total_pagina = response.data.total_pagina;

        var itemPessoas: IPessoa[] = [];

        pessoas.map((item: IRequestPessoas) => {
          return itemPessoas.push({
            id: item.pessoa.id,
            //documento: MaskCPFeCNPJ(item.pessoa.documento).valueModify,
            nome: item.pessoa.nome,
           // data_cadastro: FormatDate(item.pessoa.data_cadastro),
          });
        });

        return {
          error: false,
          response: { total_itens, total_pagina, pessoas: itemPessoas },
        };
      })
      .catch(error => {
        return {
          error: true,
        };
      });
  }

}

interface IRequestData {
  data: {

    id_perfil: number;

  };
}

export interface IPessoa {
  id: number;
  nome: string;
  //data_cadastro: string;
  //documento: string;
}

export interface IRequestPessoas {
  pessoa: IPessoa;
}

interface IResponsePessoa {
  error: boolean;
  response?: {
    total_itens: number;
    total_pagina: number;
    pessoas: IPessoa[];
  };
}


export default Services;
